import { en } from './en';

export type TranslationKeys = typeof en;

export const mr: TranslationKeys = {
  // Navigation
  nav: {
    home: 'मुख्यपृष्ठ',
    profile: 'प्रोफाइल',
    schemes: 'योजना',
    applications: 'अर्ज',
    fraudCheck: 'फसवणूक तपासणी',
    learnFinance: 'वित्त शिका',
    appTitle: 'ग्रामीण डिजिटल हक्क',
  },

  // Home Page
  home: {
    welcome: 'ग्रामीण डिजिटल हक्कांमध्ये आपले स्वागत आहे',
    subtitle: 'तुमच्यासाठी तयार केलेल्या सरकारी योजना शोधा',
    getStarted: 'सुरू करा',
    createProfile: 'तुमचे प्रोफाइल तयार करा',
    browseSchemes: 'योजना ब्राउझ करा',
    checkEligibility: 'पात्रता तपासा',
  },

  // Profile Page
  profile: {
    title: 'तुमचे प्रोफाइल',
    createTitle: 'तुमचे प्रोफाइल तयार करा',
    updateTitle: 'तुमचे प्रोफाइल अपडेट करा',
    subtitle: 'वैयक्तिक योजना शिफारसी मिळविण्यासाठी आम्हाला तुमच्याबद्दल सांगा',
    personalInfo: 'वैयक्तिक माहिती',
    age: 'वय',
    gender: 'लिंग',
    male: 'पुरुष',
    female: 'स्त्री',
    other: 'इतर',
    caste: 'जात श्रेणी',
    general: 'सामान्य',
    obc: 'ओबीसी',
    sc: 'एससी',
    st: 'एसटी',
    occupation: 'व्यवसाय',
    farmer: 'शेतकरी',
    laborer: 'मजूर',
    selfEmployed: 'स्व-रोजगार',
    salaried: 'पगारदार',
    student: 'विद्यार्थी',
    unemployed: 'बेरोजगार',
    incomeRange: 'वार्षिक उत्पन्न श्रेणी',
    below1lakh: '₹१ लाखाखाली',
    '1to3lakh': '₹१-३ लाख',
    '3to5lakh': '₹३-५ लाख',
    '5to10lakh': '₹५-१० लाख',
    above10lakh: '₹१० लाखाच्या वर',
    locationInfo: 'स्थान माहिती',
    state: 'राज्य',
    district: 'जिल्हा',
    pincode: 'पिनकोड',
    saveProfile: 'प्रोफाइल जतन करा',
    updateProfile: 'प्रोफाइल अपडेट करा',
    profileSaved: 'प्रोफाइल यशस्वीरित्या जतन केले!',
    profileUpdated: 'प्रोफाइल यशस्वीरित्या अपडेट केले!',
  },

  // Schemes Page
  schemes: {
    title: 'सरकारी योजना',
    subtitle: 'तुम्ही पात्र असलेल्या योजना शोधा',
    searchPlaceholder: 'योजना शोधा...',
    filters: 'फिल्टर',
    category: 'श्रेणी',
    level: 'स्तर',
    central: 'केंद्रीय',
    state: 'राज्य',
    allCategories: 'सर्व श्रेणी',
    agriculture: 'शेती',
    education: 'शिक्षण',
    health: 'आरोग्य',
    housing: 'गृहनिर्माण',
    employment: 'रोजगार',
    socialWelfare: 'सामाजिक कल्याण',
    viewDetails: 'तपशील पहा',
    applyNow: 'आता अर्ज करा',
    eligibility: 'पात्रता',
    estimatedBenefit: 'अंदाजे लाभ',
    match: 'जुळणी',
    basedOnProfile: 'तुमच्या प्रोफाइलवर आधारित',
    noSchemes: 'कोणतीही योजना आढळली नाही',
    createProfileFirst: 'वैयक्तिक शिफारसी पाहण्यासाठी तुमचे प्रोफाइल तयार करा',
    loading: 'योजना लोड होत आहेत...',
    interestedQuestion: 'तुम्हाला या योजनेत रस आहे का?',
    interestedMessage: 'फायद्यांचा वापर कसा करावा याबद्दल वैयक्तिक आर्थिक सल्ला मिळविण्यासाठी तुम्ही ही योजना जतन करू इच्छिता का?',
    yesInterested: 'होय, मला रस आहे',
    noThanks: 'नाही, धन्यवाद',
    saving: 'जतन करत आहे...',
    noSchemesFound: 'कोणतीही योजना आढळली नाही',
    noSchemesFilters: 'तुमच्या सध्याच्या फिल्टरशी कोणतीही योजना जुळत नाही. तुमचा शोध किंवा फिल्टर समायोजित करण्याचा प्रयत्न करा.',
    noSchemesAvailable: 'सध्या कोणतीही योजना उपलब्ध नाही. कृपया नंतर पुन्हा प्रयत्न करा.',
    clearFilters: 'फिल्टर साफ करा',
  },

  // Scheme Detail Dialog
  schemeDetail: {
    description: 'वर्णन',
    officialWebsite: 'अधिकृत वेबसाइट',
    helpline: 'हेल्पलाइन',
    close: 'बंद करा',
    visitWebsite: 'अधिकृत वेबसाइटला भेट द्या',
    callHelpline: 'हेल्पलाइनवर कॉल करा',
  },

  // Applications Page
  applications: {
    title: 'माझे अर्ज',
    subtitle: 'तुमच्या योजना अर्जांचा मागोवा घ्या',
    noApplications: 'अद्याप कोणतेही अर्ज नाहीत',
    startApplying: 'त्यांचा येथे मागोवा घेण्यासाठी योजनांसाठी अर्ज करणे सुरू करा',
    status: 'स्थिती',
    submittedOn: 'सबमिट केले',
    referenceNumber: 'संदर्भ क्रमांक',
    viewTimeline: 'टाइमलाइन पहा',
  },

  // Fraud Check Page
  fraudCheck: {
    title: 'फसवणूक शोध',
    subtitle: 'संदेश किंवा कॉल घोटाळा आहे का ते तपासा',
    inputLabel: 'संदेश प्रविष्ट करा किंवा कॉलचे वर्णन करा',
    inputPlaceholder: 'संदेश पेस्ट करा किंवा कॉलरने काय सांगितले ते वर्णन करा...',
    checkButton: 'फसवणूक तपासा',
    checking: 'विश्लेषण करत आहे...',
    result: 'विश्लेषण परिणाम',
    safe: 'सुरक्षित',
    risky: 'धोकादायक',
    safeMessage: 'हे कायदेशीर असल्याचे दिसते',
    riskyMessage: 'हा संभाव्य घोटाळा असल्याचे दिसते',
    explanation: 'स्पष्टीकरण',
  },

  // Education/Learn Finance Page
  education: {
    title: 'वित्त शिका',
    subtitle: 'तुमच्या स्वारस्याच्या योजनांवर वैयक्तिक आर्थिक सल्ला मिळवा आणि फायद्यांचा उत्तम वापर कसा करावा ते शिका',
    overallPlan: 'एकूण आर्थिक योजना',
    overallPlanDesc: 'सर्वांकडून फायद्यांचे व्यवस्थापन आणि वापर कसा करावा याबद्दल सर्वसमावेशक सल्ला मिळवा',
    schemesCount: 'योजना एकत्र',
    getOverallAdvice: 'एकूण सल्ला मिळवा',
    yourSchemes: 'तुमच्या स्वारस्याच्या योजना',
    getAdvice: 'या योजनांमधून फायद्यांचा उत्तम वापर कसा करावा याबद्दल वैयक्तिक आर्थिक सल्ला मिळवा',
    noSchemes: 'अद्याप कोणत्याही स्वारस्याच्या योजना नाहीत',
    noSchemesDesc: 'योजना ब्राउझ करा आणि वैयक्तिक आर्थिक सल्ला मिळविण्यासाठी त्यांना स्वारस्य म्हणून चिन्हांकित करा',
    getFinancialAdvice: 'आर्थिक सल्ला मिळवा',
    financialAdvice: 'आर्थिक सल्ला',
    overallAdviceTitle: 'एकूण आर्थिक योजना',
    comprehensiveAdvice: 'साठी सर्वसमावेशक आर्थिक सल्ला',
    combinedAnalysis: 'तुमच्या सर्व स्वारस्याच्या योजनांचे एकत्रित विश्लेषण',
    generatingAdvice: 'वैयक्तिक आर्थिक सल्ला तयार करत आहे...',
    generatingPlan: 'सर्वसमावेशक आर्थिक योजना तयार करत आहे...',
    overallAdviceLabel: 'एकूण सल्ला',
    keyPoints: 'मुख्य मुद्दे',
    utilizationTips: 'फायद्यांचा वापर कसा करावा',
    potentialImpact: 'संभाव्य प्रभाव',
    removeScheme: 'योजना काढा',
  },

  // Common
  common: {
    retry: 'पुन्हा प्रयत्न करा',
    loading: 'लोड होत आहे...',
    error: 'त्रुटी',
    success: 'यश',
    cancel: 'रद्द करा',
    confirm: 'पुष्टी करा',
    save: 'जतन करा',
    delete: 'हटवा',
    edit: 'संपादित करा',
    back: 'मागे',
    next: 'पुढे',
    submit: 'सबमिट करा',
    search: 'शोधा',
    filter: 'फिल्टर',
    clear: 'साफ करा',
    apply: 'लागू करा',
    close: 'बंद करा',
  },
};
